import Close from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content/Close";

type Props = { onClose: () => void };

const Content: FC<Props> = ({ onClose, children }) => (
  <div
    className="relative grid w-[stretch] gap-4 rounded-lg bg-secondary px-8 pb-8 text-center shadow-xl"
    data-testid="nft-reward-notification-container"
  >
    <Close onClose={onClose} />
    {children}
  </div>
);

export default Content;
